import React from 'react';
import * as Styled from './price-indicator.styled';
import { TypeMini, StyledVisuallyHiddenContainer } from '@at/design-system-foundation';
export var PriceIndicatorPill = function (_a) {
    var text = _a.text, hiddenText = _a.hiddenText, priceIndicatorRating = _a.priceIndicatorRating, _b = _a.displayType, displayType = _b === void 0 ? 'block' : _b, _c = _a.className, className = _c === void 0 ? '' : _c;
    return (React.createElement(Styled.StyledPriceIndicatorLozenge, { lozengeColour: priceIndicatorRating, displayType: displayType, className: className },
        React.createElement(TypeMini, { weight: "500", as: "div" }, text),
        hiddenText && React.createElement(StyledVisuallyHiddenContainer, { as: "span" }, hiddenText)));
};
